<template>
    <div>
        <vs-popup class="upload-rebate-lists-popup" title="" :active.sync="uploadRebateListsPopupActive">
            <div class="vx-row flex-wrap title-bar">
                <h3>Upload Rebate File</h3>

                <div class="flex-wrap client-specific">
                    <vs-chip transparent color="dark" class="custom-bg">
                        List Pending
                    </vs-chip>
                    
                    <!-- TODO: Add it back when the logos for all partners are added to system -->
                    <!-- <img class="partner-logo" src="../../assets/images/partner-logos/GoDaddy-Black.png" alt="" /> -->
                </div>
            </div>

            <hr>

            <div class="vx-row flex-wrap justify-start pt-5 pb-2 px-5">
                <div class="vx-col w-1/4 mb-2 text"><strong>List Details</strong></div>
            </div>

            <div v-for="(item, index) in formData" :key="`upload-row-${index}`" class="vx-row flex-wrap justify-start px-5">
                <div v-if="index !== 0" class="delete-row-icon" @click="deleteRow(index)">
                    <feather-icon icon="TrashIcon" color="dark"></feather-icon>
                </div>

                <div v-else style="margin-left:20px"></div>

                <div class="vx-col mb-2 form-field" style="margin: 5px;flex: 1">
                    <!-- TODO: Change condition to: Upload list text when no file is uploaded & List <no.> when file is uploaded -->
                    <label v-if="item['fileName'] !== ''" class="vs-input--label inline-flex pb-2">List {{ index+1 }}</label>
                    <label v-else class="vs-input--label inline-flex pb-2">Upload List</label>
                    <div class="upload-input relative">
                        <input :name="`uploadListFile-${index}`" type="file" :id="`file-${index}`" :ref="`uploadListFile-${index}`" style="cursor: pointer" v-validate="!imgLoaded ? 'required' : ''" class="absolute top-0 left-0 w-full h-full z-10 opacity-0" @change="handleFileChange($event, index)" @click="resetFileInput($event)"/>
                        <vs-button class="mt-1 upload-btn" type="filled" icon-pack="feather" icon="icon-file">Click or Drag & Drop Excel/CSV File Here</vs-button>
                        <span class="text-danger text-sm" v-show="errors.has(`uploadListFile-${index}`)">Required field</span>
                        <div class="file-errors-wrap flex flex-wrap">
                            <ul v-show="item['fileName']" class="pt-2 pr-5">
                                <li class="flex items-center">
                                    <p class="pr-1" :class=" item['fileTypeError'] || item['fileSizeError'] ? 'color-gray' : 'text-primary'">
                                        {{ item["fileName"] }}
                                    </p>
                                    <!-- NOTE: Hide remove icon if filesize or filetype error is there. -->
                                    <vs-button v-show="!item['fileTypeError'] && !item['fileSizeError']" color="danger" type="flat" icon-pack="feather" icon="icon-x" class="remove-agt-file-btn" @click="removeFile(index)"></vs-button>
                                </li>
                            </ul>
                            <p v-show="item['fileTypeError']" class="pt-2 text-danger">
                                {{ item["fileTypeError"] }}
                            </p>
                            <p v-show="item['fileSizeError']" class="pt-2 text-danger">
                                {{ item["fileSizeError"] }}
                            </p>
                        </div>
                    </div>
                    <p v-if="index == formData.length - 1" style="font-size:9px;display:flex" class="mt-3">
                        <feather-icon icon="FileIcon" color="primary" class="primary" style="width:13px;height:13px;color:#0142F8" /> <u><a :href="sampleFile.url" @click.prevent="downloadSampleFile(sampleFile)">Click Here To Download Sample Rebate List Format</a></u>
                    </p> <br>
                </div>

                <div class="vx-col mb-2 form-field" style="margin: 10px; width: 200px">
                    <label class="vs-input--label inline-flex pb-2">Period</label>
                    <v-select name="period" class="" v-model="item['period']" :options="formInit['pendingMonths']" :closeOnSelect="true" :clearable="false" v-validate="'required'" data-vv-validate-on="change" :disabled="index === 0"></v-select>
                    <span class="text-danger text-sm" v-show="errors.has('period')">Required field</span>
                </div>
            </div>

            <div class="vx-row flex justify-start" style="padding: 15px;margin-left: 24px">
                <div class="vx-col">
                    <vs-button icon="add" id="button-with-loading" type="filled" class="add-another-list-btn custom-btn" @click="addAnotherList()" :disabled="!formInit['pendingMonths'].length">Add Another List</vs-button>
                </div>
            </div>

            <hr>

            <div class="vx-row flex justify-end">
                <div class="vx-col mt-8">
                    <vs-button id="button-with-loading" color="primary" type="filled" class="custom-btn ml-auto" @click="debounceSubmit()" :disabled="fileNotUploadedError" icon-after>Submit</vs-button>
                </div>
            </div>
        </vs-popup>

        <custom-prompt :activePrompt.sync="customPrompt['activePrompt']" :title="customPrompt['title']" :buttonText="customPrompt['buttonText']" :type="customPrompt['type']" :color="customPrompt['color']" :classList="customPrompt['classList']" :accept="customPrompt['accept']">
            <!-- Success Message -->
            <div class="con-content" slot="content" v-if="customPrompt['type'] == 'success' || customPrompt['type'] == 'warning'">
                <!-- <p>Your rebate list has been uploaded successfully. We will send you an email shortly with the rebate amount and next steps.</p> 
                <br>
                <p>Thank you.</p> -->
                <p v-html="customPrompt['message']"></p>
            </div>
            
            <!-- Error Message -->
            <div class="con-content text-left" slot="content" v-else-if="customPromptError">
                <p v-html="customPromptError.response.data.message"></p>

                <p class="mt-3" v-if="customPromptError.response.data.filenames">The above errors were found in the following file(s):</p>
                <ul v-if="customPromptError.response.data.filenames" class="mt-0 text-left">
                    <li v-for="(file, i) in customPromptError.response.data.filenames" :key="`file-${i}`">
                        {{ file }}
                    </li>
                </ul>

                <!-- TODO: Confirm with Cliff -->
                <!-- <p>Please re-upload the files after making required corrections.</p> -->
            </div>
        </custom-prompt>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import CustomPrompt from '../CustomPrompt.vue';
import debounce from '@/assets/utils/debounce.js';

export default {
    name: 'UploadRebateLists',
    components: {
        'v-select': vSelect,
        CustomPrompt,
    },
    data() {
        return {
            imgLoaded: false,
            argsData: {},
            formInit: {
                pendingMonths: [],
            },
            formData: [
                {
                    period: null,
                    fileTypeError: null,
                    fileSizeError: null,
                    fileName: null,
                    filePath: null,
                    fileExtension: null,
                },
            ],
            // Custom Dialog props
            customPrompt: {
                activePrompt: false,
                title: null,
                buttonText: null,
                type: null,
                color: null,
                classList: null,
                accept: () => {
                    return true;
                },
            },
            customPromptError: null,
            sampleFile: {
                url: '/assets/sample-rebates-file.xlsx',
                label: 'sample-rebates-file',
            },
            localClientRebateStatus: null,
            uploadRebateListsPopupActive: false
        };
    },
    created() {
        this.debounceSubmit = debounce(this.submit, 500);
    },
    mounted() {
        let self = this;

        self.$root.$on('openUploadRebateListsPopup', (args) => {
            Object.assign(self.argsData, args);
            self.$set(self.formData[0], 'period', args.period);
            this.uploadRebateListsPopupActive = true;
            this.formPendingMonths(args.pendingMonths);
        });
    },
    methods: {
        openLoadingInDiv() {
            this.$vs.loading({
                container: "#div-with-loading",
                scale: 0.8,
            });
        },
        hideLoadingInDiv() {
            this.$vs.loading.close("#div-with-loading > .con-vs-loading");
        },
        // NOTE: Handles same file upload - not triggering @change bug
        resetFileInput(event) {
            event.target.value = null;
        },
        handleFileChange(event, index) {
            if(event.target.files && event.target.files[0]) {
                this.formData[index]['fileTypeError'] = '';
                this.formData[index]['fileSizeError'] = '';
                this.formData[index]['fileExtension'] = '';
    
                this.formData[index]['fileName'] = event.target.files[0].name;
                this.formData[index]['fileExtension'] = this.formData[index]['fileName'].split('.').pop();
    
                // Check File Type
                this.formData[index]['filePath'] = event.target.value;
    
                // Allowed file types
                var allowedExtensions = /(\.csv|\.xlsx|\.xls|\.ods)$/i;
    
                if (!allowedExtensions.exec(this.formData[index]['filePath'])) {
                    this.formData[index]['fileTypeError'] = 'Invalid file (Please upload .xlsx, .csv or .xls file under 25mb)';
                    return false;
                }
    
                //Check File Size
                var ogFileSize = event.target.files[0].size;
                var fileSize = Math.round(ogFileSize / 1024);
    
                if (fileSize >= 25600) {
                    this.formData[index]['fileSizeError'] =
                        'Please select a file under 25mb';
                }
    
                if (this.imgLoaded) {
                    this.imgLoaded = false;
                }
            }
        },
        formPayload() {
            let payload = {
                client_id: this.argsData.clientId,
                rebate_test_file: [],
                month: [],
                year: [],
            };

            this.formData.forEach((el, index) => {
                payload['rebate_test_file'][index] = this.$refs[`uploadListFile-${index}`][0].files[0];
                payload['month'][index] = el.period.split(' ')[0];
                payload['year'][index] = el.period.split(' ')[1];
            });

            return Object.entries(payload).reduce((fd, [key, val]) => {
                if (Array.isArray(val)) {
                    val.forEach((v, idx) => fd.append(`${key}[${idx}]`, v));
                } else {
                    fd.append(key, val);
                }
                return fd;
            }, new FormData());
        },
        removeFile(index) {
            (this.$refs[`uploadListFile-${index}`].value = null),
                (this.formData[index]['fileName'] = ''),
                (this.formData[index]['filePath'] = ''),
                (this.formData[index]['fileTypeError'] = ''),
                (this.formData[index]['fileSizeError'] = ''),
                (this.formData[index]['fileExtension'] = '');
        },
        addAnotherList() {
            this.formData.push({
                period: null,
                fileTypeError: null,
                fileSizeError: null,
                fileName: null,
                filePath: null,
                fileExtension: null,
            });
        },
        deleteRow(index) {
            this.formData.splice(index, 1);
        },
        submit() {
            this.openLoadingInDiv();
            var self = this;
            // NOTE: Validate data on frontend
            this.$validator.validateAll().then((result) => {
                if (result) {
                    self.$axiosSecureClient
                    .post('/file-upload', this.formPayload())
                    .then((response) => {
                        if(response.data.status) {
                            this.localClientRebateStatus = response.data.status;
                        }

                        // Success Dialog box
                        this.customPrompt['activePrompt'] = true;
                        this.customPrompt['type'] = response.data.type ? response.data.type.toLowerCase() : 'success';
                        this.customPrompt['title'] = 'Rebate List(s) Uploaded';
                        this.customPrompt['message'] = response.data.message;
                        this.customPrompt['color'] = response.data.type == 'Warning' ? response.data.type.toLowerCase() :'primary';
                        this.customPrompt['accept'] = () => {
                        this.uploadRebateListsPopupActive = false;
                        // TODO: Remove setTimeOut and figure out why the popup is taking time to close
                        setTimeout(() => {
                            this.$root.$emit('submitRebateList', this.localClientRebateStatus);
                        }, 1000);
                        }

                        this.hideLoadingInDiv();
                    })
                    .catch((error) => {
                        this.customPromptError = error;

                        // Error dialog box
                        this.customPrompt['activePrompt'] = true;
                        this.customPrompt['type'] = 'error';
                        this.customPrompt['classList'] = 'danger-prompt';
                        this.customPrompt['color'] = 'danger';

                        this.hideLoadingInDiv();
                    });
                }
            });
        },
        resetForm() {
            this.formData = [
                {
                    period: null,
                    fileTypeError: null,
                    fileSizeError: null,
                    fileName: null,
                    filePath: null,
                    fileExtension: null,
                },
            ];
        },
        downloadSampleFile({ url, label }) {
            this.$axiosSecure
                .get(`http://localhost:8080${url}`, { responseType: 'blob' })
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = label;
                    link.click();
                    URL.revokeObjectURL(link.href);
                })
                .catch((error) => console.error(error));
        },
        formPendingMonths(pendingMonthsLocal) {
            pendingMonthsLocal.forEach(month => {
                if(typeof month[0] === 'string' && month[0].includes('Q')) {
                    this.formInit['pendingMonths'].push(month[0] + ' ' + month[1]);
                } else {
                    const date = new Date();
                    date.setMonth(month[0]-1);
                    date.setFullYear(month[1]);
                    this.formInit['pendingMonths'].push(date.toLocaleString('en-US', {month: 'long'}) + ' ' + date.getFullYear());
                }
            })
        },
    },
    destroyed() {
        this.resetForm();
        this.$root.$off('openUploadRebateListsPopup');
    },
    computed: {
        fileNotUploadedError() {
            if (this.formData.every((x) => x.fileName)) {
                return false;
            } else {
                return true;
            }
        },
    },
};
</script>